import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import backgroundImage from "../../assets/img/fondoSiete.png";
import HeaderAdmin from "../header/HeaderAdmin";
import useNivelesPreguntas from "../../hooks/useNivelesPreguntas";
import useTemasNivel from "../../hooks/useTemasNivel";
import basureroRojo from "../../assets/img/basureroRojo.png";
import editarTema from "../../assets/img/editarTema.png";
import Swal from "sweetalert2";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const NivelesPreguntas = () => {
  const navigate = useNavigate();
  const [vistaActual, setVistaActual] = useState("seleccion");
  const [nuevoTema, setNuevoTema] = useState("");
  const [temas, setTemas] = useState([]);
  const [preguntas, setPreguntas] = useState([]);

  // ▼▼ Estados para renombrar en línea ▼▼
  const [editingTemaId, setEditingTemaId] = useState(null);
  const [editingNombre, setEditingNombre] = useState("");

  const {
    niveles,
    nivelSeleccionado,
    error,
    showMultimedia,
    multimediaUrl,
    multimediaType,
    handleNivelClick,
    handleFileChange,
    handleUpload,
    setShowMultimedia,
  } = useNivelesPreguntas();

  // obtener preguntas del nivel actual
  useEffect(() => {
    const obtenerPreguntas = async () => {
      if (!nivelSeleccionado) return;
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${API_BASE_URL}/api/preguntas/nivel/${nivelSeleccionado}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setPreguntas(response.data);
      } catch (error) {
        console.error("Error al obtener preguntas:", error);
      }
    };
    obtenerPreguntas();
  }, [nivelSeleccionado, vistaActual]);

  const eliminarPregunta = async (id) => {
    const confirmacion = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Se eliminará la pregunta permanentemente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
    });

    if (!confirmacion.isConfirmed) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_BASE_URL}/api/preguntas/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPreguntas((prev) => prev.filter((p) => p.id !== id));

      Swal.fire("Eliminada", "La pregunta ha sido eliminada.", "success");
    } catch (error) {
      console.error("Error al eliminar pregunta:", error);
      Swal.fire("Error", "No se pudo eliminar la pregunta.", "error");
    }
  };

  useEffect(() => {
    setTemas([]);
    setNuevoTema("");
    setVistaActual("seleccion");
  }, [nivelSeleccionado]);

  // obtener siguiente número (usa la lista real si está disponible)
  const obtenerSiguienteNumero = () => {
    const base = (useTemas?.length ? useTemas : temas) || [];
    const nums = base
      .map((t) => {
        const m = (t?.nombre || "").match(/Tema\s+(\d+)/i);
        return m ? parseInt(m[1], 10) : 0;
      })
      .sort((a, b) => a - b);
    for (let i = 1; i <= nums.length + 1; i++) {
      if (!nums.includes(i)) return i;
    }
    return nums.length + 1;
  };

  // eliminar tema
  const handleEliminarTema = async (id) => {
    const confirmacion = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Se eliminará el tema permanentemente.",
      icon: "warning",
      iconColor: "#fa2a00",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: " #99a3a4 ",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    });

    if (confirmacion.isConfirmed) {
      const token = localStorage.getItem("token");

      try {
        await axios.delete(`${API_BASE_URL}/api/temas/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setTemas((prevTemas) => prevTemas.filter((tema) => tema.id !== id));

        Swal.fire({
          icon: "success",
          title: "Eliminado",
          text: "El tema ha sido eliminado correctamente.",
          confirmButtonText: "Continuar",
          confirmButtonColor: "#27ae60 ",
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al eliminar el tema.",
          confirmButtonColor: "#d33",
        });
      }
    }
    await obtenerTemas();
  };

  // agregar tema
  const handleAddTema = async () => {
    const texto = nuevoTema.trim();

    if (!texto) {
      Swal.fire({
        icon: "warning",
        title: "Campo obligatorio",
        text: "Por favor, ingresa un nombre para el tema.",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    const numero = obtenerSiguienteNumero();
    const nombreFinal = texto !== "" ? texto : `Tema ${numero}`;
    const nuevo = { id: Date.now(), nombre: nombreFinal };
    setTemas((prev) => [...prev, nuevo]);

    const payload = {
      nombre: nombreFinal,
      nivel_id: nivelSeleccionado,
    };
    setNuevoTema("");
    const token = localStorage.getItem("token");

    try {
      await axios.post(`${API_BASE_URL}/api/temas/store`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    } catch (error) {}
    await obtenerTemas();
  };

  const renderMultimediaModal = () => {
    if (!showMultimedia) return null;
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
          <div className="flex justify-between items-center p-4 border-b">
            <h3 className="text-xl font-bold font-montserrat">
              Material del Nivel
            </h3>
            <button
              onClick={() => setShowMultimedia(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
          <div className="flex-grow overflow-auto p-4">
            {multimediaUrl ? (
              multimediaType === "image" ? (
                <img
                  src={multimediaUrl}
                  alt=""
                  className="max-w-full max-h-[60vh] mx-auto object-contain"
                />
              ) : (
                <video
                  src={multimediaUrl}
                  controls
                  className="max-w-full max-h-[60vh] mx-auto"
                />
              )
            ) : (
              <p className="text-center text-gray-600">
                No hay contenido multimedia.
              </p>
            )}
          </div>
          <div className="p-4 border-t">
            <input
              type="file"
              onChange={handleFileChange}
              accept="video/*,image/*"
              className="mb-2 w-full"
            />
            <button
              onClick={handleUpload}
              className="w-full bg-green-700 hover:bg-green-800 text-white py-2 rounded"
            >
              Cargar nuevo material
            </button>
          </div>
        </div>
      </div>
    );
  };

  const nombreNivel =
    niveles.find((n) => n.id === nivelSeleccionado)?.nombre || "";

  const usuarioGuardado = JSON.parse(localStorage.getItem("usuario"));
  const userId = usuarioGuardado?.id;

  const { useTemas, loading, obtenerTemas } = useTemasNivel(
    nivelSeleccionado,
    userId
  );

  // ▼▼ funciones para renombrar en línea ▼▼
  const startEditTema = (tema) => {
    setEditingTemaId(tema.id);
    setEditingNombre(tema.nombre || "");
  };

  const cancelEditTema = () => {
    setEditingTemaId(null);
    setEditingNombre("");
  };

  const saveEditTema = async (temaId, currentName) => {
    const nuevo = (editingNombre || "").trim();
    if (!nuevo) {
      Swal.fire("Campo vacío", "El nombre no puede estar vacío.", "warning");
      return;
    }
    if (nuevo === currentName) {
      // Nada que guardar
      setEditingTemaId(null);
      setEditingNombre("");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `${API_BASE_URL}/api/temas/${temaId}`,
        { nombre: nuevo }, // solo nombre
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await obtenerTemas(); // refresca lista real
      setEditingTemaId(null);
      setEditingNombre("");
      Swal.fire(
        "Actualizado",
        "El nombre del tema fue actualizado.",
        "success"
      );
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "No se pudo actualizar el nombre.", "error");
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <HeaderAdmin />
      <div className="bg-white w-full py-2 text-center text-lg font-montserrat font-extrabold">
        Identidad Institucional
      </div>

      <div className="flex-grow flex flex-col sm:flex-row p-4 space-y-4 sm:space-y-0 sm:space-x-4">
        <div className="w-full sm:w-1/4 bg-white rounded-lg p-4 shadow-lg">
          <h2 className="text-xl font-bold mb-4">Niveles</h2>
          <div className="space-y-2">
            {niveles.map((nivel) => (
              <button
                key={nivel.id}
                onClick={() => handleNivelClick(nivel.id)}
                className={`w-full text-left px-4 py-2 rounded font-bold ${
                  nivelSeleccionado === nivel.id
                    ? "bg-green-700 text-white"
                    : "bg-gray-100 text-gray-800 hover:bg-green-600 hover:text-white"
                }`}
              >
                {nivel.nombre}
              </button>
            ))}
          </div>
        </div>

        <div className="w-full sm:w-3/4 bg-white rounded-lg p-4 shadow-lg flex flex-col">
          {nivelSeleccionado ? (
            <>
              <h2 className="text-2xl font-bold mb-4">{nombreNivel}</h2>

              {vistaActual === "seleccion" && (
                <div className="flex flex-grow flex-col justify-center items-center w-full px-4">
                  <div className="w-full max-w-lg mx-auto space-y-8 mb-8">
                    <button
                      onClick={() => setVistaActual("quizzes")}
                      className="bg-green-700 font-bold text-white py-6 px-10 rounded-xl text-xl transition-transform transform hover:scale-110 w-full shadow-md hover:shadow-lg"
                    >
                      ¡Duelo de saberes!
                    </button>
                    <button
                      onClick={() => setVistaActual("evaluacion")}
                      className="bg-green-700 font-bold text-white py-6 px-10 rounded-xl text-xl transition-transform transform hover:scale-110 w-full shadow-md hover:shadow-lg"
                    >
                      Desafío final
                    </button>
                  </div>
                </div>
              )}

              {vistaActual === "quizzes" && (
                <div className="flex flex-col items-center">
                  <h2 className="text-2xl font-bold text-center mb-6">
                    Temas: {nombreNivel}
                  </h2>

                  <div className="flex mb-6 gap-2 w-full max-w-3xl">
                    <input
                      type="text"
                      placeholder="Nombre del nuevo tema"
                      value={nuevoTema}
                      onChange={(e) => setNuevoTema(e.target.value)}
                      className="border p-2 rounded flex-grow"
                    />
                    <button
                      onClick={handleAddTema}
                      className="bg-green-700 hover:bg-green-600 font-bold text-white px-6 py-3 rounded"
                    >
                      Crear tema
                    </button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
                    {useTemas.map((tema) => (
                      <div
                        key={tema.id}
                        className="border p-4 rounded shadow hover:shadow-lg flex flex-col justify-between h-30"
                      >
                        {/* Título editable */}
                        <div className="mb-2">
                          {editingTemaId === tema.id ? (
                            <div className="flex items-center gap-2">
                              <input
                                className="border rounded px-2 py-1 w-full"
                                value={editingNombre}
                                onChange={(e) =>
                                  setEditingNombre(e.target.value)
                                }
                                onKeyDown={(e) => {
                                  if (e.key === "Enter")
                                    saveEditTema(tema.id, tema.nombre);
                                  if (e.key === "Escape") cancelEditTema();
                                }}
                                autoFocus
                              />
                              <button
                                onClick={() =>
                                  saveEditTema(tema.id, tema.nombre)
                                }
                                className="bg-green-700 hover:bg-green-800 text-white px-3 py-1 rounded"
                              >
                                Guardar
                              </button>
                              <button
                                onClick={cancelEditTema}
                                className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded"
                              >
                                Cancelar
                              </button>
                            </div>
                          ) : (
                            <div className="flex items-start gap-2">
                              <h3
                                className="text-lg font-bold flex-1 cursor-text"
                                title="Doble clic para renombrar"
                                onDoubleClick={() => startEditTema(tema)}
                              >
                                {tema.nombre}
                              </h3>
                              <button
                                onClick={() => startEditTema(tema)}
                                className="border border-gray-300 rounded px-2 py-1 text-xs"
                                title="Renombrar tema"
                              >
                                Renombrar
                              </button>
                            </div>
                          )}
                        </div>

                        <div className="flex justify-end gap-2 mt-auto">
                          <button
                            onClick={() => navigate(`/admin/tema/${tema.id}`)}
                            className=" border-2 border-green-700 shadow hover:shadow-lime-600 p-2 rounded flex items-center justify-center"
                            title="Editar contenido del tema"
                          >
                            <img
                              src={editarTema}
                              alt="Editar"
                              className="w-5 h-5"
                            />
                          </button>

                          <button
                            onClick={() => handleEliminarTema(tema.id)}
                            className="border-2 border-red-700 shadow hover:shadow-red-600 p-2 rounded flex items-center justify-center"
                            title="Eliminar tema"
                          >
                            <img
                              src={basureroRojo}
                              alt="Eliminar"
                              className="w-5 h-5"
                            />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {vistaActual === "evaluacion" && (
                <div className="mt-8">
                  <h2 className="text-2xl font-bold mb-4 text-center">
                    Evaluación Final
                  </h2>

                  <div className="flex justify-center mb-6">
                    <button
                      onClick={() =>
                        navigate(
                          `/admin/crear-pregunta?nivel=${nivelSeleccionado}`
                        )
                      }
                      className="bg-green-700 hover:bg-green-600 font-bold text-white px-6 py-3 rounded"
                    >
                      Crear nueva pregunta
                    </button>
                  </div>

                  <div className="mt-6 bg-gray-100 p-4 rounded-lg shadow">
                    <h3 className="text-xl font-bold mb-4">Preguntas</h3>
                    {preguntas.length > 0 ? (
                      <ul className="space-y-3">
                        {preguntas.map((pregunta) => (
                          <li
                            key={pregunta.id}
                            className="flex justify-between items-center bg-white p-3 rounded shadow"
                          >
                            <span className="flex-1 mr-3">
                              {pregunta.texto_pregunta}
                            </span>

                            <div className="flex items-center gap-2">
                              {/* Editar (verde) */}
                              <Link
                                to={`/admin/editar-pregunta/${pregunta.id}?nivel=${nivelSeleccionado}`}
                                state={{ pregunta }}
                                className="bg-green-700 hover:bg-green-700 text-white px-3 py-1 rounded text-sm transition-colors"
                                aria-label="Editar pregunta de evaluación"
                                title="Editar pregunta"
                              >
                                Editar
                              </Link>

                              {/* Eliminar */}
                              <button
                                onClick={() => eliminarPregunta(pregunta.id)}
                                className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                                aria-label="Eliminar pregunta"
                                title="Eliminar pregunta"
                              >
                                🗑
                              </button>
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-center text-gray-600">
                        No hay preguntas registradas aún.
                      </p>
                    )}
                  </div>
                </div>
              )}
            </>
          ) : (
            <p className="text-center text-gray-600">
              Selecciona un nivel para ver su contenido
            </p>
          )}
        </div>
      </div>

      {error && (
        <div className="fixed bottom-0 left-0 right-0 bg-red-500 text-white p-2 text-center">
          {error}
        </div>
      )}
      {renderMultimediaModal()}
    </div>
  );
};

export default NivelesPreguntas;
